package com.iregained.site.components.sections.contact.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val ContactRoutingContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White).padding(top = 100.px, bottom = 60.px)
}

val ContactRoutingGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1000.px).gap(32.px).padding(leftRight = 24.px).margin(top = 48.px)
}

val RoutingCardStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().height(100.percent).padding(40.px).backgroundColor(rgba(235, 235, 235, 0.9)).borderRadius(16.px)
            // Default subtle border
            .border(2.px, LineStyle.Solid, colorMode.toSitePalette().custom.lightGray).cursor(Cursor.Pointer)
            .transition(Transition.of("all", 250.ms))
    }
    hover {
        Modifier
            // Lift effect
            .transform { translateY((-8).px) }
            // Brand border on hover
            .border(2.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary)
            .boxShadow(0.px, 12.px, 32.px, color = Colors.Black.copy(alpha = 10))
    }
}

val RoutingIconWrapperStyle = CssStyle.base {
    Modifier.size(64.px).borderRadius(50.percent)
        .display(DisplayStyle.Flex).justifyContent(JustifyContent.Center).alignItems(AlignItems.Center)
        .margin(bottom = 24.px)
}

val RoutingIconStyle = CssStyle.base {
    Modifier.size(50.px)
}

val RoutingCardTitleStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(1.5.cssRem).fontWeight(FontWeight.Bold)
        .margin(bottom = 12.px)
}

val RoutingCardDescStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText.toRgb().copyf(alpha = 0.8f)).fontSize(1.cssRem)
        .lineHeight(1.6)
}